import fyLogoSvg from "@/assets/pages/home/_00Global/fylogo.svg";

interface Props {
  className?: string;
}

export const FyLogo = ({ className = "" }: Props): JSX.Element => {
  return (
    <img 
      src={fyLogoSvg}
      alt="Forever Yours Films Logo" 
      className={`${className}`} 
    />
  );
}; 